import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import { useQuery } from '@tanstack/react-query';

const GetMyOpenApiKeys = graphql(`
  query GetMyOpenApiKeys {
    me {
      user {
        account {
          openApiKeys {
            id
            name
            clientId
          }
        }
      }
    }
  }
`);

const useGetMyOpenApiKeys = () => {
  const { data, ...rest } = useQuery({
    queryKey: meKeys.openApiKeys(),
    queryFn: () => {
      return gqlClient.request(GetMyOpenApiKeys);
    },
  });

  return {
    openApiKeys: data?.me.user.account.openApiKeys,
    ...rest,
  };
};

export default useGetMyOpenApiKeys;
